// extracted by mini-css-extract-plugin
module.exports = {"Controlled":"Courses_Controlled__3zJ3E","CostCell":"Courses_CostCell__3mmyr"};